module.exports = __webpack_public_path__ + "assets/img/smartProductBg3.3ff0e6d7.png";